export default __webpack_public_path__ + "5dde865c1153ec89a0a3ebfef8147afe.svg";